export default function getNumberedName(names, root) {
    if (!names || !names.length) {
        return root;
    }
    const regexp = new RegExp(`^(${escapeRegex(root)})(\\d*)$`, 'gmi');

    const indexes = names
        .filter(name => isIndexedName(name, regexp))
        .map(name => extractIndex(name, root))
        .filter(index => Number.isInteger(index))
        .reduce(sortIndexes, []);

    const missingIndex = getMissingIndex(indexes);
    const nextIndex = getNextIndex(missingIndex, indexes);

    return root + (nextIndex ? nextIndex : '');
}

function escapeRegex(string) {
    return string.replace(/[()]/g, '\\$&');
}

function isIndexedName(name, regexp) {
    return name && name.match(regexp)
}


function extractIndex(name, root) {
    return +name.split(root)[1];
}


function sortIndexes(acc, value) {
    const nextIndex = acc.findIndex(i => value < i);
    const index = nextIndex > -1 ? nextIndex : acc.length;
    acc.splice(index, 0, value);
    return acc;
}


function getMissingIndex(indexes) {
    return [...(new Array(indexes[indexes.length - 1]).keys())].filter(standardIndex => {
        return !indexes.filter(index => index === standardIndex).length;
    })[0];
}


function getNextIndex(missingIndex, allIndexes) {
    return Number.isInteger(missingIndex) ? missingIndex : allIndexes[allIndexes.length - 1] + 1;
}
